<template>
    <button
        v-if="!isAdDisabled"
        :class="$style.button"
        data-interface-target="no-ad-header-button"
        @click="adDisabledStore.openDisabledAdModal()"
    >
        <img
            :class="$style.icon"
            :src="NoAdImg"
            alt="No Ad"
        />
        <Typography
            type="label"
            size="l"
        >
            {{ $tr('desktopHeader.noAds') }}
        </Typography>
    </button>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import Typography from '@/components_new/Typography.vue'
import { useAdDisabledStore } from '@/store/ad-disabled-store'

import NoAdImg from './images/no-ad.webp'

const adDisabledStore = useAdDisabledStore()
const { isAdDisabled } = storeToRefs(adDisabledStore)
</script>

<style module>
.button {
    flex-shrink: 0;
    padding: 8px 16px 8px 8px;
    background: var(--carbon-400);
    border-radius: 1000px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
}

.button:hover,
.button:focus {
    outline: 0.5px solid #2e53b2;
    background: var(--carbon-300);
    box-shadow: 0 0 30px 0 #447d9e inset;
}

.icon {
    width: 36px;
    height: 36px;
}
</style>
